import React from 'react';

/**
 * NoticeIcon — Two arcs orbiting in opposite directions.
 * Fallback spinner when no Lucide icon is available.
 */

const keyframes = `
@keyframes mksys-orbit { to { transform: rotate(360deg); } }
@keyframes mksys-orbit-reverse { to { transform: rotate(-360deg); } }
@media (prefers-reduced-motion: reduce) {
  .mksys-orbit, .mksys-orbit-reverse { animation: none !important; }
}
`;

export const NoticeIcon: React.FC<{ size?: number; color?: string }> = ({
  size = 22,
  color = '#6b7280',
}) => {
  const stroke = 2;
  const r = (size - stroke) / 2;
  const center = size / 2;

  return (
    <span style={{ display: 'inline-flex', width: size, height: size, position: 'relative' }}>
      <style>{keyframes}</style>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
        <circle
          cx={center} cy={center} r={r}
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${r * Math.PI * 0.75} ${r * Math.PI * 1.25}`}
          className="mksys-orbit"
          style={{ animation: 'mksys-orbit 0.9s linear infinite', transformOrigin: 'center' }}
        />
        <circle
          cx={center} cy={center} r={r * 0.55}
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          opacity={0.35}
          strokeDasharray={`${r * 0.55 * Math.PI * 0.6} ${r * 0.55 * Math.PI * 1.4}`}
          className="mksys-orbit-reverse"
          style={{ animation: 'mksys-orbit-reverse 0.7s linear infinite', transformOrigin: 'center' }}
        />
      </svg>
    </span>
  );
};
